import { render } from "./AlarmCard.vue?vue&type=template&id=2aa643d6"
import script from "./AlarmCard.vue?vue&type=script&lang=js"
export * from "./AlarmCard.vue?vue&type=script&lang=js"

import "./AlarmCard.vue?vue&type=style&index=0&id=2aa643d6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__